import { z } from "zod";
import { MethodsInputSchema } from "../methodsInput";

export const UniformFlowInputsSchema = MethodsInputSchema.extend({
  exploitationFlow: z.number().positive(),
  saturatedThicknessBase: z.number(),
  saturatedThicknessTop: z.number(),
  hydraulicConductivity: z.number().positive(),
  hydraulicGradient: z.number(),
}).refine((data) => data.saturatedThicknessBase > data.saturatedThicknessTop, {
  path: ["saturatedThicknessBase"],
});

export type UniformFlowInputs = z.infer<typeof UniformFlowInputsSchema>;
